"use client";

import {
  type ReactElement,
  type ReactNode,
  createContext,
  useCallback,
  useContext,
} from "react";
import {
  type HelpSpaTarget,
  helpSpaHref,
  helpSpaHrefFromBase,
} from "./help-spa-path";

/** Null = public `/help/{org}` links; the portal sets its own base. */
const HelpLinkBaseContext = createContext<string | null>(null);

export function HelpLinkBaseProvider({
  base,
  children,
}: {
  readonly base: string;
  readonly children: ReactNode;
}): ReactElement {
  return (
    <HelpLinkBaseContext.Provider value={base}>
      {children}
    </HelpLinkBaseContext.Provider>
  );
}

/** Link builder for help targets; same components serve `/help` and the portal. */
export function useHelpHref(
  orgSlug: string,
): (target: HelpSpaTarget) => string {
  const base = useContext(HelpLinkBaseContext);
  return useCallback(
    (target: HelpSpaTarget): string =>
      base === null
        ? helpSpaHref(orgSlug, target)
        : helpSpaHrefFromBase(base, target),
    [base, orgSlug],
  );
}
